import utils from '../Utils';
import apiClient from './ApiInterceptor';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const fetchEvents = async (branch, fromDate, toDate, onlyCourtesies = false) => {
    try {
        const params = {
            from: dayjs.utc(fromDate).format('YYYY-MM-DD HH:mm:ss'),
            to: dayjs.utc(toDate).format('YYYY-MM-DD HH:mm:ss'),
            branch: branch,
            onlyCourtesies: onlyCourtesies,
          };

        const response = await apiClient.get('/events', { params });
        return response.data;
    } catch (error) {
        console.error('EventsApi - fetchEvents, Error fetching data:', error);
    }
};

export const fetchAttendees = async (event) => {
  try {
    const params = {
      is_unique: event.hasOwnProperty('is_unique') ? event.is_unique : false,
      is_edited: event.hasOwnProperty('is_edited') ? event.is_edited : false,
      start_date: utils.getFormattedDateInUTC(event.start_date),
      end_date: utils.getFormattedDateInUTC(event.end_date),
      event_id: event.event_id,
    };

    const response = await apiClient.get('/events/attendees', { params });
    return response.data;
  } catch (error) {
    console.error('EventsApi - fetchAttendees, Error fetching data:', error);
  }
};

export const fetchBatchAttendees = async (events) => {
  try {
    const formattedEvents = events.map((event) => ({
      event_id: event.event_id,
      is_unique: event.hasOwnProperty("is_unique") ? event.is_unique : false,
      is_edited: event.hasOwnProperty("is_edited") ? event.is_edited : false,
      start_date: event.start_date.format("YYYY-MM-DD HH:mm:ss"),
      end_date: event.end_date.format("YYYY-MM-DD HH:mm:ss"),
      unique_id: event.unique_id,
    }));

    const response = await apiClient.post("/events/attendees/batch", {
      events: formattedEvents,
    });

    const attendeesByUniqueId = response.data;

    return events.map((event) => ({
      ...event,
      attendees: attendeesByUniqueId[event.unique_id] || [],
    }));
  } catch (error) {
    console.error("EventsApi - fetchAllAttendees, Error fetching data:", error);
    return events.map((event) => ({ ...event, attendees: [] }));
  }
};


export const fetchEvent = async (event_id, is_unique, is_edited, start_date, end_date) => {
  try {
    const params = {
      event_id,
      is_unique,
      is_edited,
      start_date: utils.getFormattedDateInUTC(start_date),
      end_date: utils.getFormattedDateInUTC(end_date),
    };
    const response = await apiClient.get(`/events/${event_id}`, { params });
    return response.data;
  } catch (error) {
    console.error('EventsApi - fetchEvent, Error fetching event:', error);
  }
};
